import { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { jwtDecode } from 'jwt-decode';
import Footer from './components/nav/Footer';
import Header from './components/nav/Header';
import RequireAuth from './components/RequireAuth';
import Unauthorized from './components/Unauthorized';
import { AuthenticationContext } from './context/Authentication';
import { AuthProvider } from './context/AuthProvider';
import About from './pages/about/About';
import Abouttwo from './pages/About';
import AdvanceSearchMovies from './pages/AdvanceSearchMovies';
import AdvanceSearchTv from './pages/AdvanceSearchTv';
import AdvanceSearchAll from './pages/AdvanceSearchAll';
import Demo from './pages/Demo';
import Allinone from './pages/Allinone';
import MainSearch from './pages/Advance/MainSearch';
import Search from './pages/AdvSearch';
import Login from './pages/auth/login/Login';
import ForgotPassword from './pages/auth/login/ForgotPassword';
import Register from './pages/auth/register/Register';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Survey from './pages/survey/Survey';
import Terms from './pages/Terms';
import Howitwork from './pages/Howitwork';
import AdvSearch from './pages/AdvSearch';

// Rating: Education
// import EducationLanding from './pages/education/EducationLanding';
import EducationRating from './pages/education/EducationRating';
// Rate Political Policies
// Rating: Entertainement
import CollisionRating from './pages/CollisionRating';
import EntertainmentRating from './pages/entertainment/EntertainmentRating';
// Admin Stuff
import Sidebar from './pages/admin/components/sidebar/Sidebar';
import NewSide from './pages/admin/components/sidebar/NewSide';
import Topbar from './pages/admin/components/topbar/Topbar';
import AdminHome from './pages/admin/pages/home/Home';
import Ratings from './pages/admin/pages/ratings/Ratings';
import User from './pages/admin/pages/user/User';
import UserList from './pages/admin/pages/userList/UserList';
import Newuselist from './pages/admin/pages/userList/NewUserlist';
import Productadd from './pages/admin/pages/productadd/Productadd';

import EditQuestion from './pages/admin/pages/editQuestion/EditQuestion';
import NewQuestion from './pages/admin/pages/newQuestion/NewQuestion';
import Question from './pages/admin/pages/Question/Question';
import Companyquestion from './pages/admin/pages/Question/Companyquestion';

import Category from './pages/admin/pages/Category/Category';
import EditCategory from './pages/admin/pages/editCategory/EditCategory';
import NewCategory from './pages/admin/pages/newCategory/NewCategory';
import AdvancedSearch from './pages/AdvancedSearch';
import ContactUs from './pages/admin/pages/ContactUs/ContactUs';
import GetContactUs from './pages/admin/pages/ContactUs/GetContactUs';
// import AdvanceSearchAll from './pages/AdvanceSearchAll';

// Home Page
import Home from './pages/home/Home';
import Hometwo from './pages/home2/Hometwo';

// Partners Page
import Partner from './pages/partners/Partner';

// Contest Page
import ErrorPage from './pages/error/ErrorPage';
import QRCodeHandler from './pages/QRCodeHandler';
import VerifiedPurchaseHandler from './pages/VerifiedPurchaseHandler';
import CookieConsent from './pages/CookieConsent';
// Business Sign-up Page
import BusinessSignUp from './pages/businessSignUp/BusinessSignUp';
import Businesslogin from './pages/businesslogin/Businesslogin';
import BusinessProfile from './pages/Profile/BusinessProfile';
import Questionbus from './pages/Question/Questionbus';
import Rating from './pages/admin/pages/Companyrating/Rating';
import OneTimeLink from './pages/admin/pages/Companyrating/OneTimeLink ';
import BusinessSingle from './pages/Businessrate/BusinessSingle';

// Dashboard
import Dashboard from './pages/Dashboard/Dashboard';
import Refer from './pages/Dashboard/Refer';

// Reward Sign-up Page
import RewardSignUp from './pages/reward/RewardSignUp';
// Points Marketplace
import Marketplace from './pages/marketplace/marketplace';

//profile page
import Profile from './pages/Profile/Profile';
import Content from './pages/admin/pages/Content/Content';
import AddContent from './pages/admin/pages/Content/AddContent';
import EditContent from './pages/admin/pages/Content/EditContent';
import GetContent from './pages/admin/pages/Content/GetContent';
import Policies from './pages/admin/pages/Policies/Policies';
import LegalList from './pages/admin/pages/Legal/LegalList';
import LegalDetail from './pages/admin/pages/Legal/LegalDetail';

export const ROLES = {
  Admin: 1,
  Student: 2,
  Faculty: 3,
  User: 4,
  Business: 5,
};

function Menu() {
  return (
    <Routes>
      {/* normal path */}
      <Route path="*" element={<ErrorPage />} />
      <Route path="/" element={<Home />} />
      <Route path="/hometwo" element={<Hometwo />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/un" element={<Unauthorized />} />
      <Route path="/search" element={<Search />} />
      <Route path="/new" element={<AdvSearch />} />
      <Route
        path="/advance-search/oldmovies"
        element={<AdvanceSearchMovies />}
      ></Route>
      <Route path="/advance-search/oldtv" element={<AdvanceSearchTv />}></Route>
      <Route path="/advance-search/oldall" element={<Demo />}></Route>
      <Route path="/advance-search/all" element={<Allinone />}></Route>

      {/* AdvanceSearchAll */}
      <Route path="/searchall" element={<MainSearch />}></Route>
      <Route path="/about" element={<About />} />
      <Route path="/company-rating/:id/:ratingId" element={<OneTimeLink />} />
      <Route path="/company-rating/:id" element={<OneTimeLink />} />
      <Route path="/business/:id" element={<BusinessSingle />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/howitworks" element={<Howitwork />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/partners" element={<Partner />} />
      <Route path="/qr-code/:code" element={<QRCodeHandler />} />
      <Route
        path="/verify-purchase/:token"
        element={<VerifiedPurchaseHandler />}
      />
      <Route path="/businessSignUp" element={<BusinessSignUp />} />
      <Route path="/businesslogin" element={<Businesslogin />} />
      <Route path="/rewardSignUp" element={<RewardSignUp />} />
      <Route path="/add-product" element={<Productadd />} />
      {/* refer */}
      <Route path="/refer/:id" element={<Refer />} />
      {/* this path is for user/admin/Faculty/student */}
      <Route
        element={
          <RequireAuth
            allowedRoles={[
              ROLES.User,
              ROLES.Faculty,
              ROLES.Student,
              ROLES.Admin,
            ]}
          />
        }
      >
        <Route path="/profile" element={<Profile />} />
        <Route path="/rate/:cat/:id" element={<EntertainmentRating />} />

        {/* <Route path="/rate/:cat/:id" element={<EntertainmentRating />} /> */}
        <Route path="/rate/collision" element={<CollisionRating />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/marketplace" element={<Marketplace />} />
      </Route>

      {/*this path is for admin/Faculty/student  */}
      <Route
        element={
          <RequireAuth
            allowedRoles={[ROLES.Faculty, ROLES.Student, ROLES.Admin]}
          />
        }
      >
        {/* <Route path="/profile" element={<Profile />} /> */}
        <Route path="/rate/:cat" element={<EducationRating />} />
      </Route>

      {/* this pathe is for only business  */}
      <Route
        element={<RequireAuth allowedRoles={[ROLES.Business, ROLES.Admin]} />}
      >
        <Route path="/businessprofile" element={<BusinessProfile />} />
        <Route path="/businessquestion" element={<Questionbus />} />

        {/* <Route path="/company-rating" element={<OneTimeLink />} /> */}

        {/* <Route path="/businessprofile" element={<BusinessProfile />} /> */}

        {/* add question of business  */}
        {/* genrate question dispaly page */}
      </Route>

      {/*this path is for admin  */}
      <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
        <Route path="admin" element={<AdminHome />} />
        <Route path="/admin/users" element={<Newuselist />} />
        <Route path="/admin/user/:id" element={<User />} />
        <Route path="/admin/ratings" element={<Ratings />} />

        <Route path="/admin/questions" element={<Question />} />
        <Route path="/admin/company-question" element={<Companyquestion />} />
        <Route path="/admin/edit-questions" element={<EditQuestion />} />
        <Route path="/admin/newQuestion" element={<NewQuestion />} />

        <Route path="/admin/contactus" element={<ContactUs />} />
        <Route path="/admin/contactus/view/:id" element={<GetContactUs />} />
        <Route path="/admin/category" element={<Category />} />
        <Route path="/admin/update-category" element={<EditCategory />} />
        <Route path="/admin/newcategory" element={<NewCategory />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/admin/content" element={<Content />} />
        <Route path="/admin/content/add" element={<AddContent />} />
        <Route path="/admin/content/edit/:id" element={<EditContent />} />
        <Route path="/admin/content/view/:id" element={<GetContent />} />
        <Route path="/admin/policies" element={<Policies />} />
        <Route
          path="/admin/legal/terms"
          element={
            <LegalList
              type="terms"
              title="Terms & Conditions"
              description="Manage and publish Terms versions"
            />
          }
        />
        <Route
          path="/admin/legal/privacy"
          element={
            <LegalList
              type="privacy"
              title="Privacy Policy"
              description="Manage and publish Privacy versions"
            />
          }
        />
        <Route
          path="/admin/legal/terms/new"
          element={<LegalDetail type="terms" title="Terms & Conditions" />}
        />
        <Route
          path="/admin/legal/terms/:id"
          element={<LegalDetail type="terms" title="Terms & Conditions" />}
        />
        <Route
          path="/admin/legal/privacy/new"
          element={<LegalDetail type="privacy" title="Privacy Policy" />}
        />
        <Route
          path="/admin/legal/privacy/:id"
          element={<LegalDetail type="privacy" title="Privacy Policy" />}
        />
      </Route>
    </Routes>
  );
}

function App(props) {
  let data = '';
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const isWindowAvailable = () => typeof window !== 'undefined';
  const login = () => {
    setIsLoggedIn(true);
  };
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 768);
    };

    handleResize(); // Call once on mount to set initial value
    window.addEventListener('resize', handleResize); // Update on window resize

    return () => window.removeEventListener('resize', handleResize); // Cleanup
  }, []);
  const logout = () => {
    setIsLoggedIn(false);
  };

  if (localStorage.getItem('loginToken') && isLoggedIn === false) {
    data = jwtDecode(localStorage.getItem('loginToken'));
    setIsLoggedIn(true);
  } else if (localStorage.getItem('loginToken')) {
    data = jwtDecode(localStorage.getItem('loginToken'));
  }
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // if (isWindowAvailable()) document.documentElement.dir = "ltr";

  return (
    <AuthenticationContext.Provider value={{ isLoggedIn, login, logout }}>
      <AuthProvider>
        {window.location.pathname.includes('admin') &&
        data?.role === ROLES.Admin &&
        data?.role !== undefined ? (
          <>
            <div className="flex h-[100vh] w-full bg-background-100 dark:bg-background-900 overflow-x-hidden">
              {/* Sidebar */}
              <NewSide
                isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
              />

              {/* Main Content */}
              <div className="h-full w-full font-dm dark:bg-navy-900 overflow-x-hidden">
                <main className="flex-none transition-all dark:bg-navy-900 md:pr-2 w-full">
                  <div>
                    <Topbar
                      isSidebarOpen={isSidebarOpen}
                      toggleSidebar={toggleSidebar}
                    />
                    <div
                      className=" w-full   overflow-x-hidden bg-slate-100"
                      style={{ minHeight: 'calc(10vh - 50px)' }}
                    >
                      <Menu />
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </>
        ) : (
          <div className="main-app">
            <Header />
            <CookieConsent />
            <Menu />
            <Footer />
          </div>
        )}
      </AuthProvider>
    </AuthenticationContext.Provider>
  );
}

export default App;
